<template>
  <div class="home-page page">
    <div class="page-wrap" v-if="displayPage">
      <!-- 顶部 -->
      <page-top :isShowHome="false"></page-top>
      <!-- 头部 -->
      <Header :list="headerList" currentIndex="0"></Header>
      <!-- 主体 -->
      <main class="main">
        <!-- 轮播图 -->
        <section class="banner-wrap">
          <banner :list="bannerList"></banner>
        </section>

        <section class="content">
          <div class="c-left">
            <!-- 公司概况 -->
            <!-- <div class="company-wrap" :style="'background-image: linear-gradient(rgba(235, 234, 234, 0.8), rgba(235, 234, 234, 0.8)), url('+comanyDesc.cover+');'">
            -->
            <div class="company-wrap" v-animate-on-scroll="'animate__fadeInUp'">
              <div class="title">
                <span class="chinese-name">基地介绍</span>
                <span class="english-name"> BASE INTRODUCTION</span>
              </div>
              <!-- <div class="title w">
                <span class="c-title">公司简介</span>
                <span class="english-name">COMPANY PROFILE</span>
              </div> -->
              <div class="desc w">
                <div class="company-left">
                  <div
                    class="article-content"
                    v-html="comanyDesc.articleContent"
                  ></div>
                  <button class="learn-more" @click="handleCompany(currentTab)">
                    了解更多 >>
                  </button>
                </div>
                <div class="company-right" v-if="comanyDesc.cover">
                  <img class="img" :src="comanyDesc.cover" alt="logo" />
                </div>
              </div>
            </div>
            <!-- 业务板块 -->
            <div
              class="business-wrap"
              v-animate-on-scroll="'animate__fadeInUp'"
            >
              <div class="title">
                <span class="chinese-name">业务板块</span>
                <span class="english-name"> BUSINESS SECTORS</span>
              </div>
              <div class="tab-wrap">
                <div class="tab-list">
                  <div
                    class="item"
                    :class="{
                      active: currentTab.categoryCode == item.categoryCode
                    }"
                    v-for="(item, index) in businessSectorList"
                    :key="index"
                    @click="handleTabClick(item)"
                  >
                    <img class="img" :src="getIconUrl(item)" alt="logo" />
                    <div class="name">{{ item.categoryName }}</div>
                  </div>
                </div>
                <div class="tab-content" v-if="currentTab">
                  <div class="left-content">
                    <div class="article-name">
                      {{ currentTab.contArticle.articleName }}
                    </div>
                    <div
                      class="article-content"
                      v-html="currentTab.contArticle.articleContent"
                    ></div>
                    <button
                      class="learn-more"
                      @click="handleBusiness(currentTab)"
                    >
                      查看所有服务 >>
                    </button>
                  </div>
                  <div class="right-content">
                    <img
                      class="img"
                      :src="currentTab.contArticle.cover"
                      alt="logo"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 新闻中心 -->
            <div class="news-wrap" v-animate-on-scroll="'animate__fadeInUp'">
              <div class="title">
                <span class="chinese-name">新闻资讯</span>
                <span class="english-name"> NEWS & INFORMATION</span>
              </div>
              <div class="tab-content">
                <div class="news-cover" style="display: none">
                  <news-banner :list="newsbannerList"></news-banner>
                </div>
                <div class="news-content">
                  <div class="tab-title">
                    <div
                      v-for="(item, index) in titles"
                      :key="index"
                      @mouseover="handleNewsClick(item)"
                      :class="[
                        'title-item',
                        { 'title-selected': item.isSelected }
                      ]"
                    >
                      {{ item.title }}
                    </div>
                  </div>
                  <div class="new-list" v-if="newsList">
                    <div
                      class="news-item"
                      v-for="(item, index) in newsList"
                      :key="index"
                      @click="toArticleDetail(item)"
                    >
                      <div class="news-title">
                        {{ item.articleName }}
                      </div>
                      <div class="news-time">
                        {{ item.releaseTime }}
                      </div>
                    </div>
                  </div>
                  <el-empty
                    description="暂无内容~"
                    v-if="newsList.length == 0"
                  ></el-empty>
                  <div class="tab-more" @click="handleNews(currentTab)">
                    <span>查看更多{{ currentNews?.title || '基地动态' }}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      aria-hidden="true"
                      role="img"
                      font-size="20"
                      class="ml-2 iconify iconify--gitee icon-arrow-right-circle-solid"
                      width="1em"
                      height="1em"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 16 16"
                    >
                      <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h16v16H0z"></path>
                        <path
                          fill="currentColor"
                          fill-rule="nonzero"
                          d="M8 1a7 7 0 110 14A7 7 0 018 1zm.318 3.818a.5.5 0 000 .707L10.293 7.5H4.5a.5.5 0 000 1h5.792l-1.974 1.975a.5.5 0 00.707.707l2.829-2.828.011-.013a.503.503 0 00.033-.039l-.044.052a.502.502 0 00.121-.198l.009-.03.005-.021a.469.469 0 00.01-.084L12 8v-.02a.503.503 0 00-.005-.052L12 8a.502.502 0 00-.011-.105l-.005-.022-.009-.029-.006-.018a.497.497 0 00-.104-.167l-.011-.013-2.829-2.828a.5.5 0 00-.707 0z"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <!-- 合作伙伴 -->
            <div
              class="coop-partner w"
              v-if="coopList.length"
              v-animate-on-scroll="'animate__fadeInUp'"
            >
              <div class="title">
                <span class="chinese-name">服务客户</span>
                <span class="english-name">SERVE CUSTOMERS</span>
              </div>
              <div class="coop-tip">
                <span
                  class="bg-clip-text text-transparent bg-gradient-to-r from-[#3055FE] to-[#0BD9ED]"
                  >他们都选择了通文服务</span
                >
              </div>
              <div class="tab-content">
                <div class="list">
                  <div
                    class="item"
                    v-for="(item, index) in coopList"
                    :key="index"
                    @click="openLink(item)"
                  >
                    <div class="img-wrap">
                      <img class="img" :src="item.cover" alt="" />
                    </div>
                    <div class="content-wrap">
                      <div class="txt">{{ item.articleName }}</div>
                      <!-- <div class="article-content">{{item.articleContent}}</div> -->
                    </div>
                  </div>
                </div>
                <!-- 页码 -->
                <div
                  class="m-bot"
                  v-if="coopList.length > 0 && pageCount > pageSize"
                >
                  <el-pagination
                    background
                    layout="prev, next"
                    :page-size="pageSize"
                    :total="pageCount"
                    @current-change="changePageClick"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <!-- 底部 -->
      <Footer></Footer>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import pageTop from '@/components/common/pageTop.vue'
import Header from '@/components/train/header.vue'
import Footer from '@/components/train/footer.vue'
import Banner from '@/components/common/banner.vue'
import NewsBanner from '@/components/common/news-banner.vue'

import {
  getHomeBannerList,
  getArticleById,
  getChildernList,
  getArticlePage
} from '@/api/home/home.js'

export default {
  components: { pageTop, Header, Banner, NewsBanner, Footer },
  data() {
    return {
      displayPage: true,
      loading: false,
      headerList: [], //header的tab列表
      bannerImgHeight: '', //轮播图图片高度
      bannerList: [], //轮播图列表
      newsbannerList: [], //新闻轮播图列表
      newsList: [],

      currentMatchIndex: 0,

      pageSize: 4, //分页数量
      pageCount: 0, //赛事列表总数
      comanyDesc: {
        cover: null
      },
      businessSectorList: null,
      currentTab: null,
      titles: [
        {
          id: 1,
          title: '基地动态',
          isSelected: true,
          code: '128',
          tabcode: '127'
        },
        {
          id: 2,
          title: '政策法规',
          isSelected: false,
          code: '129',
          tabcode: '127'
        }
      ],
      currentNews: null,
      coopList: [],
      currentIndex: 0
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.startAnimationLoop()
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    clearInterval(this.intervalId)
  },
  methods: {
    openLink(item) {
      if (item.articleUrl) {
        window.open(item.articleUrl)
      }
    },
    //统一获取数据
    fetchData() {
      this.getHomeBannerList(2)
      this.getArticleData('1991030034663313409')
      this.getBusinessList(104)
      this.getArticlePage(112)
      this.getCoopPage(106)
    },
    //获取首页banner
    getHomeBannerList(id) {
      getHomeBannerList(id).then((res) => {
        if (!res.data) return
        this.bannerList = res.data
      })
    },
    // 基地介绍
    getArticleData(id) {
      getArticleById(id).then((res) => {
        if (!res.data) return
        this.comanyDesc = res.data
      })
    },
    getBusinessList(id) {
      getChildernList(id).then((res) => {
        if (!res.data) return
        this.businessSectorList = res.data
        this.currentTab = this.businessSectorList[0]
      })
    },
    handleTabClick(item) {
      this.currentTab = item
    },
    handleNewsClick(item) {
      this.titles.forEach((p) => {
        p.isSelected = p.code == item.code ? true : false
      })
      this.currentNews = item
      this.getArticlePage(item.code)
    },
    //获取文章列表
    getArticlePage(categoryCode) {
      getArticlePage({
        page: 1,
        limit: 6,
        categoryCode: categoryCode
      }).then((res) => {
        console.log(res.data)
        if (!res.data) return
        this.newsList = res.data.list
        this.newsbannerList = this.newsList.map((p) => {
          return {
            bannerUrl: p.cover,
            linkUrl: p.articleId
          }
        })
      })
    },
    getCoopPage(categoryCode, page = 1) {
      getArticlePage({
        page: page,
        limit: 4,
        categoryCode: categoryCode
      }).then((res) => {
        console.log(res.data)
        if (!res.data) return
        this.coopList = res.data.list
        this.pageCount = Number(res.data.count)
      })
    },
    //切换页面
    changePageClick(page) {
      this.getCoopPage(106, page)
    },
    handleCompany() {
      let url =
        '/article?categoryId=108&linkType=1&tabcode=102&seccode=108&id=317582750246152'
      this.$router.push(url)
    },
    handleBusiness(currentTab) {
      let url =
        '/tabList?categoryId=' +
        currentTab.categoryCode +
        '&linkType=' +
        currentTab.linkType +
        '&tabcode=104&seccode=' +
        currentTab.categoryCode +
        '&id=' +
        currentTab.linkUrl
      this.$router.push(url)
    },
    getIconUrl(item) {
      // 技能提升使用本地图片
      if (item.categoryName === '技能提升') {
        return require('@/assets/images/icon-35.png')
      }
      // 其他使用接口返回的iconUrl
      return item.iconUrl
    },
    handleNews() {
      let url = ''
      if (this.currentNews == null) {
        url = '/imageText?categoryId=112&linkType=3&tabcode=103&seccode=112'
      } else {
        url =
          '/imageText?categoryId=' +
          this.currentNews.code +
          '&linkType=3&tabcode=103&seccode=' +
          this.currentNews.code
      }

      this.$router.push(url)
    },
    toArticleDetail(item) {
      let url =
        '/articleDetail?categoryId=112&linkType=3&tabcode=103&seccode=112&id=' +
        item.articleId
      this.$router.push(url)
    },
    startAnimationLoop() {
      this.triggerAnimation() // 立即播放一次
      this.intervalId = setInterval(() => {
        this.triggerAnimation()
      }, 3000) // 每3秒触发一次
    },
    triggerAnimation() {
      if (this.businessSectorList) {
        this.currentIndex =
          (this.currentIndex + 1) % this.businessSectorList.length
        this.currentTab = this.businessSectorList[this.currentIndex]
      }
    }
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.path == '/train') {
          this.displayPage = true
        } else {
          this.displayPage = false
        }
      },
      // 一进页面就执行
      immediate: true,
      // 深度观察监听
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  display: flex;
  flex-direction: column;

  .main {
    flex: 1;
    // padding-bottom: 100px;
    background-color: #ffffff;

    .banner-wrap {
      position: relative;
      min-width: 1200px;
      height: 1050px;
      overflow: hidden;
    }
    .c-title {
      font-size: 34px;
      padding-left: 17px;
      border-left: 3px solid rgb(12, 108, 228);
      font-weight: 700;
    }
    .english-name {
      margin-left: 10px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      // margin-bottom: 100px;

      .c-left {
        flex: 1;

        // padding-bottom: 70px;

        .company-wrap {
          position: relative;
          height: 710px;
          background: linear-gradient(to bottom, #ebf2ff, #ffffff);
          // background-repeat: no-repeat;
          // background-position: center;
          // background-size: cover;

          .introductionStyle {
            height: 710px;
            width: 100%;
            top: 0;
            left: 0;

            position: absolute;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
          }
          .title {
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            padding-top: 60px;
            font-family: 'Arial', sans-serif;
            letter-spacing: 2px;

            .chinese-name {
              font-size: 34px;
              padding-left: 17px;
              font-weight: 700;
            }
            .english-name {
              margin-top: 6px;
            }
          }
          .desc {
            margin-top: 60px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .company-left {
              flex: 1;

              line-height: 30px;
              display: inline-block;
              word-break: normal;
              text-align: justify;
              text-indent: 2em;

              .article-content {
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 8;
              }
              .learn-more {
                margin-top: 30px;
                width: 300px;
                height: 50px;
                text-align: center;
                line-height: 50px;
                background: #2a79ee;
                border-radius: 4px;
                font-size: 20px;
                font-weight: 700;
                color: #fff;
                cursor: pointer;
                position: relative;
              }
            }
            .company-right {
              flex: 1;
              margin-left: 60px;

              img {
                width: 100%;
                height: 400px;
                border-radius: 10px;
              }
            }
          }
        }
        .business-wrap {
          background-image: url('https://static.fjtwfw.com/static/fjtwfw/news_bg.png');
          background-repeat: no-repeat;
          background-position: 37% -38px;
          background-size: cover;

          .title {
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            padding-top: 40px;
            font-family: 'Arial', sans-serif;
            letter-spacing: 2px;

            .chinese-name {
              font-size: 34px;
              padding-left: 17px;
              font-weight: 700;
            }
            .english-name {
              margin-top: 6px;
            }
          }
          .tab-wrap {
            margin: 50px auto;
            width: 1200px;
            .tab-list {
              padding: 0px 20px;
              display: flex;
              height: 150px;

              justify-content: space-around;
              align-items: center;
              background: #fff;
              box-shadow: 0 11px 31px 0 #98afd31f;
              border-radius: 8px;
              .item {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 10px 10px;

                .img {
                  width: 80px;
                  height: 80px;
                }
                .name {
                  font-size: 16px;
                }
              }
              .active {
                background: #ecf4ff;
                border-radius: 6px;
                color: #2a79ee;
              }
            }
            .tab-content {
              height: 500px;
              display: flex;
              margin-top: 88px;

              .left-content {
                flex: 1;
                display: flex;
                flex-direction: column;
                margin-left: 20px;

                .article-name {
                  color: #1a3a5c;
                  font-weight: 700;
                  font-size: 24px;
                  line-height: 31px;
                  margin-bottom: 40px;
                }
                .article-content {
                  font-size: 18px;
                }
                .learn-more {
                  margin-top: 30px;
                  width: 300px;
                  height: 50px;
                  text-align: center;
                  line-height: 50px;
                  background: #2a79ee;
                  border-radius: 4px;
                  font-size: 20px;
                  font-weight: 700;
                  color: #fff;
                  cursor: pointer;
                  position: relative;
                }
              }
              .right-content {
                margin-left: 140px;
                padding-top: 10px;

                width: 100%; /* 或者具体宽度，比如 800px */
                max-width: 480px; /* 可选限制最大宽度 */
                aspect-ratio: 16/9;

                .img {
                  max-width: 100%; /* 最大宽度不超过容器的宽度 */
                  max-height: 100%; /* 最大高度不超过容器的高度 */
                  min-height: 320px;
                  object-fit: cover; /* 保持图片的宽高比 */
                  border-radius: 10px;
                }
              }
            }
          }
        }
        .news-wrap {
          margin: 50px auto;
          width: 1200px;

          .title {
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            padding-top: 20px;
            font-family: 'Arial', sans-serif;
            letter-spacing: 2px;

            .chinese-name {
              font-size: 34px;
              padding-left: 17px;
              font-weight: 700;
            }
            .english-name {
              margin-top: 6px;
            }
          }
          .tab-content {
            height: 600px;
            width: 100%;
            display: flex;
            align-items: center;

            .news-cover {
              width: 48%;

              .img {
                width: 580px;
                height: 350px;
              }
            }
            .news-content {
              // width: 50%;
              width: 100%;
              min-height: 500px;
              margin-left: 30px;
              position: relative;

              .tab-title {
                display: flex;
                justify-content: stretch;

                .title-item {
                  flex: 1;
                  text-align: center;
                  padding: 0 20px;
                  border-bottom: 4px solid #e4e7ed;
                  font-size: 20px;
                  color: #1a3a5c;
                  cursor: pointer;
                  width: 200px;
                  height: 80px;
                  line-height: 80px;
                  text-align: center;
                }
                .title-selected {
                  color: #2a79ee;
                  font-size: 22px;
                  font-weight: 700;
                  border-bottom: 4px solid #2a79ee;
                }
              }
              .new-list {
                padding: 10px 20px;
                display: flex;
                flex-direction: column;
                .news-item {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 18px 0;

                  .news-title {
                    flex: 1;
                    display: -webkit-box;
                    word-break: break-all;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    font-size: 16px;
                  }

                  .news-time {
                    margin-left: 20px;
                    color: #999;
                  }
                }
                .news-item:hover .news-title,
                .news-item:hover .news-time {
                  color: #2a79ee;
                  cursor: pointer;
                }
                .news-item {
                  border-bottom: 1px dashed #f1f1f1;
                }
              }
              .tab-more {
                position: absolute;
                bottom: 0;
                left: 25%;
                border: 1px solid #2a79ee;
                color: #2a79ee;
                font-size: 18px;
                width: 50%;
                height: 3rem !important;
                margin: 0px auto;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 0.25rem !important;
                cursor: pointer;
                span {
                  margin-right: 20px;
                }
              }
            }
          }
        }
        .coop-partner {
          margin: 50px auto;
          width: 1200px;
          .title {
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            padding-top: 20px;
            font-family: 'Arial', sans-serif;
            letter-spacing: 2px;

            .chinese-name {
              font-size: 34px;
              padding-left: 17px;
              font-weight: 700;
            }
            .english-name {
              margin-top: 6px;
            }
          }
          .coop-tip {
            text-align: center;
            padding: 6px;
            margin: 20px auto;
            font-size: 18px;
            border-top: 1px solid #e0e0e0;
            border-bottom: 1px solid #e0e0e0;
            width: 400px;
            font-weight: bold;

            background: linear-gradient(90deg, #f72d7b 0%, #ffbb23 80%);
            -webkit-background-clip: text; /* 必须加上这个才能让渐变应用到文字上 */
            background-clip: text;
            color: transparent; /* 文字颜色设置为透明 */
          }
          .tab-content {
            height: 360px;
            width: 100%;

            .list {
              display: flex;
              flex-wrap: wrap;

              .item {
                cursor: pointer;
                display: flex;
                flex-direction: column;
                flex: 0 0 20%;
                box-shadow: 0 2px 12px 0 rgba(32, 32, 32, 0.1);
                margin: 10px;
                margin-right: 30px;
                padding: 10px;

                .img-wrap {
                  width: 100%; /* 容器的宽度 */
                  height: 100%; /* 容器的高度 */
                  display: flex;
                  justify-content: center; /* 水平居中 */
                  align-items: center; /* 垂直居中 */
                  overflow: hidden; /* 超出部分隐藏 */
                  img {
                    max-width: 100%; /* 最大宽度不超过容器的宽度 */
                    max-height: 100%; /* 最大高度不超过容器的高度 */
                    object-fit: contain; /* 保持图片的宽高比 */
                  }
                }
                .content-wrap {
                  margin-top: 18px;
                  // border-top: 1px solid rgb(188, 189, 188);
                  .txt {
                    margin: 0px auto;
                    font-size: 15px;
                    font-weight: 700;
                    color: #1a3a5c;
                    text-align: center;
                  }
                  .article-content {
                    margin-left: 22px;
                    margin-top: 20px;
                    font-size: 14px;
                    color: #1a3a5c;
                    line-height: 20px;
                  }
                }
              }
            }
            .m-bot {
              margin-top: 24px;
              margin-bottom: 24px;

              .el-pagination {
                display: flex;
                justify-content: center;

                ::v-deep .el-icon {
                  font-weight: 700;
                  font-size: 28px;
                }
                ::v-deep .btn-prev {
                  width: 47px;
                  height: 47px;
                  border-radius: 50%;
                  border: 1px solid #e4e4e4;
                  background: #fff;
                }
                ::v-deep .btn-next {
                  width: 47px;
                  height: 47px;
                  border-radius: 50%;
                  border: 1px solid #e4e4e4;
                  background-color: #fff;
                  margin-left: 30px;
                  font-weight: 700;
                  font-size: 28px;
                }

                ::v-deep .btn-prev:enabled {
                  color: #409eff;
                }

                ::v-deep .number {
                  width: 40px;
                  height: 40px;
                  line-height: 40px;
                  border: 1px solid #e4e4e4;
                  background-color: #fff;
                }

                ::v-deep .btn-next:enabled {
                  color: #409eff;
                }

                ::v-deep .active {
                  color: #fff;
                  background-color: #409eff;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
